var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-group-item",class:{active: _vm.isItemActive},on:{"click":_vm.handleClick}},[_c('base-font',{staticClass:"group-item-title",attrs:{"weight":"bold"}},[_vm._v(_vm._s(_vm.item.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }